/**
 * Where this app is mounted in the URL.
 *
 * The ERP answers under /admin on duhokstationery.com, and at the ROOT on
 * hosts that mount it there (erp.vylo-tech.com; new.duhokstationery.com did
 * too until it was retired to a redirect) — one build, both mounts. The prefix
 * is read from the PATH at boot rather than compiled in or looked up per host,
 * so no build variant, no host table, and no second deployment: whichever
 * address the browser used, the app knows where it is standing.
 *
 * React Router is given this as its `basename`, which rewrites every <Link>,
 * navigate() and route match automatically — all 226 absolute-path literals in
 * the app keep working untouched. What it CANNOT rewrite is a raw
 * `window.open('/…')`, because that never reaches the router. Those call sites
 * (printing, the customer display) go through `appUrl()` below.
 */

/** The prefix the dashboard is served under on a shared domain. */
export const ADMIN_BASE = '/admin';

/**
 * The router basename for this page load: '/admin' when the URL says so, else
 * '' (the root mount). Computed from the live path, so it is correct before
 * React renders and stays correct for the life of the document — a navigation
 * out of /admin cannot happen, because the basename keeps every route inside it.
 */
export function routerBasename(): string {
  const p = window.location.pathname;
  return p === ADMIN_BASE || p.startsWith(`${ADMIN_BASE}/`) ? ADMIN_BASE : '';
}

/**
 * An in-app path made absolute for something that bypasses the router —
 * `window.open`, a printed link, an <iframe src>. Pass the same path you would
 * give <Link to>; you get it back with the mount prefix applied.
 */
export function appUrl(path: string): string {
  return `${routerBasename()}${path}`;
}
